function ImagePreviewModal({ image, open, onClose }) {

    if (!open) return null;

    return (
        <>
            <div
                className="fixed inset-0 bg-black/80 z-50"
                onClick={onClose}
            ></div>

            <div className="fixed inset-0 z-50 flex items-center justify-center p-10">

                <img
                    src={image}
                    alt="preview"
                    className="max-w-[90%] max-h-[90%] rounded-xl shadow-2xl"
                />

                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-white text-4xl"
                >
                    ×
                </button>

            </div>
        </>
    );
}

export default ImagePreviewModal;